import { generatePath } from '@ps/web-core-utils';
import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { select } from '@swf/core/store';
import { Banner, MakeClubPublicToast, useHomeGamesWidget } from '@swf/poker';

import TopBar from '../TopBar/TopBar';

export interface RouteProps {
  children?: React.ReactNode;
}

const RouteComponent = ({ children }: RouteProps) => {
  const aliases = useSelector(select.cms.getAliases);
  const cashGamesPath = aliases.homeGamesCashGames ?? '';
  const clubsPath = aliases.homeGamesClubs ?? '';
  const tournamentsPath = aliases.homeGamesTournaments ?? '';
  const { widgetSelect } = useHomeGamesWidget();
  const clubs = useSelector(widgetSelect.clubs);

  const { pathname } = useLocation();
  const hasClubs = !isEmpty(clubs);
  const isMainPage = [cashGamesPath, clubsPath, tournamentsPath]
    .map((key) => generatePath(key, {}))
    .includes(pathname);
  const showTopBar = hasClubs && isMainPage;

  return (
    <>
      <MakeClubPublicToast />
      <Banner isMainPage={isMainPage} />
      {showTopBar && <TopBar />}
      {children}
    </>
  );
};

export default RouteComponent;
